const showPopupBtn = document.querySelectorAll(".feedback-open");
const closePopupBtn = document.querySelectorAll(".feedback-close");
const popup = document.getElementById("videoPopup");
let zIndex;

if (popup) {
  // @ts-ignore
  zIndex = window.getComputedStyle(popup.parentElement).zIndex;
}

export function showPopup() {
  if (popup) {
    popup.style.display = "block";
    popup.classList.add("fadeIn");
    popup.classList.remove("fadeOut");

    if (popup.parentElement) {
      // @ts-ignore
      popup.parentElement.style.zIndex = 100;
    }

    // Play the video
  }
}

function hidePopup() {
  if (popup) {
    const video = popup.querySelector("video");
    if (video) {
      video.pause();
      video.currentTime = 0; // Reset the video to the beginning
    }
    popup.classList.add("fadeOut");
    popup.classList.remove("fadeIn");

    if (popup.parentElement) {
      popup.parentElement.style.zIndex = zIndex;
    }

    // Hide the popup after the animation ends
    setTimeout(() => {
      popup.style.display = "none";
    }, 300); // 300ms is the duration of the animation
  }
}

window.onclick = function (event) {
  if (event.target === popup) {
    hidePopup();
  }
};

for (let i = 0, len = showPopupBtn.length; i < len; i++) {
  // @ts-ignore
  showPopupBtn[i].onclick = showPopup;
}

for (let i = 0, len = closePopupBtn.length; i < len; i++) {
  // @ts-ignore
  closePopupBtn[i].onclick = hidePopup;
}
